/**
 * Fixes for the Bloomreach autosuggest dropdown.
 *
 * 1. Don't restore stale suggestions after clear.
 *    Native search "x" clears the input via input/search events (not keyup).
 *    Bloomreach only clears last_template_data on keyup when the query is
 *    short, and its focus handler re-renders whatever last_template_data
 *    still holds.
 *
 * 2. Make the category suggestions navigate.
 *    See the category link section below.
 */
(function () {
  function isSearchInput(el) {
    return !!(
      el &&
      el.tagName === 'INPUT' &&
      (el.type === 'search' || el.id === 'header-search-input' || el.classList.contains('search-field'))
    );
  }

  function getResultsContainer(input) {
    if (!input) return null;
    if (input.id) {
      var byId = document.getElementById('blm-autosuggest-search-results-' + input.id);
      if (byId) return byId;
    }
    return (
      (input.parentElement && input.parentElement.querySelector('.blm-autosuggest-search-results')) ||
      document.querySelector('.blm-autosuggest-search-results')
    );
  }

  function clearAutosuggestState(input) {
    var panel = getResultsContainer(input);
    if (panel) panel.innerHTML = '';
    if (input) input.dataset.originalQuery = '';

    try {
      var autosuggest = window.BloomreachModules && window.BloomreachModules.autosuggest;
      if (autosuggest && typeof autosuggest.setCurrentAutosuggestRequestState === 'function') {
        autosuggest.setCurrentAutosuggestRequestState({ last_template_data: null });
      }
    } catch (e) {}
  }

  function handleEmpty(input) {
    if (!isSearchInput(input)) return;
    if (String(input.value || '').trim()) return;
    clearAutosuggestState(input);
  }

  document.addEventListener(
    'input',
    function (event) {
      handleEmpty(event.target);
    },
    true
  );

  document.addEventListener(
    'search',
    function (event) {
      handleEmpty(event.target);
    },
    true
  );

  // Run after Bloomreach's focus listener so a stale restore is cleared again
  document.addEventListener(
    'focusin',
    function (event) {
      var input = event.target;
      if (!isSearchInput(input) || String(input.value || '').trim()) return;
      clearAutosuggestState(input);
      setTimeout(function () {
        if (!String(input.value || '').trim()) clearAutosuggestState(input);
      }, 0);
    },
    true
  );

  /**
   * Category suggestions ("Sprinklers", "Nozzles", "Rain Bird") are rendered
   * with href="#", and Bloomreach's click handler calls preventDefault() and
   * then BloomreachModules.search.load(categoryId). That only renders into an
   * in-page search container, so it requires an existing search/category page
   * with a query already in the URL; anywhere else it bails and the link does
   * nothing at all.
   *
   * Instead, point each one at the search page filtered by that category. The
   * search module reads facet filters from the `fq` URL parameter, and
   * `category:<id>` is a valid filter for these ids.
   */
  var CATEGORY_LINK = '.blm-autosuggest__suggestion-term-link--category';

  function buildCategoryHref(link) {
    var categoryId = link.getAttribute('data-category-id');
    if (!categoryId) return '';

    // The parent <li> holds the term this category belongs to, whose link
    // already carries the correctly-encoded query and tracking parameters.
    var group = link.closest('.blm-autosuggest__category-results');
    var termLink = group && group.parentElement && group.parentElement.querySelector(':scope > a[href]');
    var base = termLink && termLink.getAttribute('href');

    if (!base) {
      var config = (window.bloomreachConnector && window.bloomreachConnector.config) || {};
      var input = document.querySelector('#header-search-input, input[type="search"], .search-field');
      var query = input ? String(input.value || '').trim() : '';
      base =
        (config.search_page_url || '/search') +
        '?' +
        (config.default_search_parameter || 'q') +
        '=' +
        encodeURIComponent(query);
    }

    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'fq=' + encodeURIComponent('category:' + categoryId);
  }

  function pointCategoryLinkAtSearch(link) {
    var href = buildCategoryHref(link);
    if (href) link.setAttribute('href', href);
    return href;
  }

  // Give the link a real destination before it is used, so hovering shows the
  // target and modified clicks (new tab, middle-click) behave like any link.
  document.addEventListener(
    'pointerover',
    function (event) {
      var link = event.target && event.target.closest && event.target.closest(CATEGORY_LINK);
      if (link) pointCategoryLinkAtSearch(link);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest && event.target.closest(CATEGORY_LINK);
      if (!link || !pointCategoryLinkAtSearch(link)) return;
      // Keep the event away from Bloomreach's handler, which would cancel it.
      event.stopPropagation();
    },
    true
  );
})();
